/* =============================================================================
=    CSS
============================================================================= */
export default {
  container: {
    width: '100vw',
    height: '100vh',
    color: 'white',
    background: 'black',
    position: 'fixed',
    zIndex: '400',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    padding: '40px 40px 100px 40px',
  },
  controlsContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    // iOS notch
    '@media only screen and (max-width:960px)': {
      top: 'env(safe-area-inset-top, 0px)',
    }
  },
  control: {
    top: '40px',
    height: '47%',
    width: '48px',
    fontSize: '40px',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'absolute',
    transition: 'all .2s ease-in',
    zIndex: '1',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent'
  },
  closeBtn: {
    zIndex: '500',
    position: 'absolute',
    right: '80px',
    top: '10px',
    fontSize: '20px',
    cursor: 'pointer',
    // iOS notch
    '@media only screen and (max-width:960px)': {
      top: '44px',
    }
  },
  controlLeft: {
    left: '70px'
  },
  controlRight: {
    right: '70px'
  },
  galleryContainer: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    '&>div.slick-arrow': {
      width: '50px',
      height: '50px'
    },
    '& > .slick-slider, & .slick-list, & .slick-track, & .slick-slide': {
      height: 'inherit'
    }
  },
  galleryImageContainer: {
    position: 'relative',
    height: '100%',
    display: 'flex !important',
    alignItems: 'center',
    outline: 'none',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent'
  },
  gallerySlider: {
    '& .slick-slide': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .slick-slide > div': {
      height: '100%',
      width: '100%'
    }
  },
  galleryImage: {
    maxHeight: '100%',
    maxWidth: '100%',
    outline: 'none',
    width: 'auto',
    margin: 'auto',
    WebkitTouchCallout: 'default',
    WebkitUserSelect: 'default',
    KhtmlUserSelect: 'default',
    MozUserSelect: 'default',
    msUserSelect: 'default',
    userSelect: 'default'
  },
  thumbnailRow: {
    position: 'absolute',
    left: '50%',
    right: '40px',
    bottom: '0',
    height: '60px',
    float: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    transition: 'left .4s ease-in-out'
  },
  thumbImage: {
    height: '60px',
    width: 'auto',
    cursor: 'pointer'
  },
  videoThumbnail: {
    verticalAlign: 'middle'
  },
  playBtn: {
    height: '75px',
    width: '75px',
    borderRadius: '50%',
    backgroundColor: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    transition: 'all .2s ease',
    border: '1px solid black',
    cursor: 'pointer',
    '&:hover': {
      background: 'transparent',
      color: 'black'
    },
    '&>.material-icons': {
      fontSize: '40px'
    },
    position: 'absolute',
    zIndex: '5'
  },
  playBtnHover: {
    background: 'transparent',
    color: 'black'
  },
  videoOnHover: {
    '&:after': {
      position: 'absolute',
      left: '0',
      right: '0',
      top: '0',
      bottom: '0',
      opacity: '.5'
    }
  },
  galleryVideoContainer: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    justifyContent: 'center',
    height: 'inherit'
  },
  socialShare: {
    display: 'flex',
    alignItems: 'center',
    zIndex: '500',
    position: 'absolute',
    right: '110px',
    top: '8px',
    fontSize: '20px',
    cursor: 'pointer',
    justifyContent: 'space-between',
    paddingRight: '10px',
    paddingBottom: '10px',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    // iOS notch
    '@media only screen and (max-width:960px)': {
      top: '44px',
    }
  },
  iconList: {
    width: '0',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    transition: 'all .4s ease'
  },
  expanded: {
    width: '100%',
    overflow: 'visible',
    animation: '.4s $removeHiddenOverflow'
  },
  '@keyframes removeHiddenOverflow': {
    'from': {
      overflow: 'hidden'
    }
  },
  shareIcon: {
    paddingRight: '15px',
    fontSize: '18px',
    cursor: 'pointer',
    right: '0'
  },
  socialIcon: {
    fontSize: '20px',
    color: 'white',
    marginLeft: '8px',
    marginRight: '8px',
    textDecoration: 'none',
    cursor: 'pointer'
  },
  '@media(max-width: 960px)': {
    thumbnailRow: {
      display: 'none'
    },
    container: {
      padding: '40px'
    }
  },
  '@media(max-width: 570px)': {
    container: {
      padding: '20px'
    },
    control: {
      width: '20px'
    },
    closeBtn: {
      right: '20px',
      fontSize: '30px'
    },
    shareIcon: {
      fontSize: '25px'
    },
    socialShare: {
      right: '70px'
    },
    iconList: {
      marginRight: '24px'
    },
    socialIcon: {
      fontSize: '30px'
    },
    controlLeft: {
      left: '10px'
    },
    controlRight: {
      right: '10px'
    }
  },
  '@media only screen and (orientation:portrait)': {
    galleryImage: {
      height: 'auto',
      maxWidth: '100%'
    }
  }
};
